export default class ActivityEventAttachmentModel {
  id?: number;

  path!: string;

  filename!: string;
}
